import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CARD_BY_USER, GET_CARD_BY_USER_SUCCESS, GET_CARD_BY_USER_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCardByUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/memberships`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CARD_BY_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CARD_BY_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CARD_BY_USER_ERROR, payload: error });
  }
}

export function* watchGetCardByUser() {
  yield takeEvery(GET_CARD_BY_USER, getCardByUser);
}

function* getCardByUserSaga() {
  yield all([fork(watchGetCardByUser)]);
}

export default getCardByUserSaga;
